import {useRef, useEffect, useCallback} from "react";

export function useDebounce(fn, delay = 500) {
    const timer = useRef(null);

    const debouncedFn = useCallback(
        (...args) => {
            clearTimeout(timer.current);
            timer.current = setTimeout(() => fn(...args), delay);
        },
        [fn, delay]
    );

    useEffect(() => () => clearTimeout(timer.current), []);

    return debouncedFn;
}
